import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProfileService {
    headers: Headers;
    options: RequestOptions;
    baseAPIurl: string = '';

    constructor(private _http: Http) {
        console.log("welcome to profile service")
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        var Token = localStorage.getItem("AccessToken");
        this.headers.append("Authorization", "Bearer " + Token);
        this.options = new RequestOptions({ headers: this.headers });
        this.baseAPIurl = environment.baseAPIUrl;
    }


    VerifierRecord(SSN) {
        debugger;
        return this._http.get(this.baseAPIurl + "Profile/VerifierRecord?SSN=" + SSN, this.options);

    }

    PermissiblePurpose(ObjectDetails) {
        debugger;
        return this._http.post(this.baseAPIurl + "Profile/PermissibleCount", ObjectDetails, this.options)

    }

    Payment(PaymentDetails) {
        return this._http.post(this.baseAPIurl + "Profile/Payment", PaymentDetails, this.options)
    }

    RecordOfVerifier(OrderId) {
        debugger;
        return this._http.get(this.baseAPIurl + "Profile/RecordOfVerifier?OrderId=" + OrderId, this.options)

    }

    GetOrderHistory(Email) {
        debugger;
        return this._http.get(this.baseAPIurl + "Profile/GetOrderHistory?Email=" + Email, this.options)

    }

    GetBillingHistory(Email) {
        debugger;
        return this._http.get(this.baseAPIurl + "Profile/GetBillingHistory?Email=" + Email, this.options)

    }

    GetPermissibleCount() {
        debugger;
        return this._http.get(this.baseAPIurl + "Profile/GetPermissibleCount", this.options)
    }

    GetRunningFor() {
        return this._http.get(this.baseAPIurl + "Profile/GetRunningFor", this.options)
    }

    GuestUserRegister(UserId) {
        return this._http.get(this.baseAPIurl + "Profile/GuestUserRegister?UserId=" + UserId, this.options)
    }

    GenerateEmailForPassword(UserId) {
        debugger;
        return this._http.get(this.baseAPIurl + "IdentityMail/GenerateEmailForPassword?UserId=" + UserId, this.options)
    }

    CompanyNameMatchForEmployer(SSN) {
        debugger;
        return this._http.get(this.baseAPIurl + "Employer/CompanyNameMatchForEmployer?SSN=" + SSN, this.options)
    }

    ReportDetailsWhenCompanyMatch(SSN) {
        debugger;
        return this._http.get(this.baseAPIurl + "Employer/ReportDetailsWhenCompanyMatch?SSN=" + SSN, this.options)
    }

    ListOfEmployee(CustomerId) {
        debugger;
        return this._http.get(this.baseAPIurl + "Employer/ListOfEmployee?CustomerId=" + CustomerId, this.options)
    }

    // GetEmployeeDetailsInEdit(CustomerId){
    //     debugger;
    //     return this._http.get(this.baseAPIurl + "Employer/GetEmployeeDetailsInEdit?CustomerId="+ CustomerId, this.options)
    // }

    UpdateEmployeeDetails(EmployeeUpdatedData) {
        debugger;
        return this._http.post(this.baseAPIurl + "Employer/UpdateEmployeeDetails", EmployeeUpdatedData, this.options)
    }

    DeactivateTheEmployee(EmployeeId) {
        debugger;
        return this._http.get(this.baseAPIurl + "Employer/DeactivateTheEmployee?EmployeeId=" + EmployeeId, this.options)
    }

    UploadBulkRecord(formData) {
        debugger;
        let headers = new Headers()
        let options = new RequestOptions({ headers: headers });
        headers.append("Authorization", "Bearer " + localStorage.getItem("AccessToken"));
        return this._http.post(this.baseAPIurl + "/Employer/UploadBulkRecord", formData, options)
    }

    VerifierList() {
        return this._http.get(this.baseAPIurl + "/Admin/VerifierList", this.options)
    }

    GetCompanyName() {
        return this._http.get(this.baseAPIurl + "/Admin/GetCompanyName", this.options)
    }

    UpdateVerifierDetails(UserDetails) {
        return this._http.post(this.baseAPIurl + "/Admin/UpdateVerifierDetails", UserDetails, this.options)
    }

    GetPackageList() {
        return this._http.get(this.baseAPIurl + "/Admin/GetPackageList", this.options)
    }

    UpdatePackagesDetails(PackageDetails) {
        return this._http.post(this.baseAPIurl + "/Admin/UpdatePackagesDetails", PackageDetails, this.options)
    }

    PackagesDelete(PackageId) {
        return this._http.get(this.baseAPIurl + "/Admin/PackagesDelete?PackageId=" + PackageId, this.options)
    }

    UpdateAndInsertPersonalPackages(PersonalPackageDetails) {
        debugger;
        return this._http.post(this.baseAPIurl + "/Admin/UpdateAndInsertPersonalPackages", PersonalPackageDetails, this.options)
    }

    GetPersonalPackageList() {
        return this._http.get(this.baseAPIurl + "/Admin/GetPersonalPackageList", this.options)
    }

    GetServices(PersonalPackageId) {
        return this._http.get(this.baseAPIurl + "/Admin/GetServices?PersonalPackageId=" + PersonalPackageId, this.options)
    }

    PersonalPackageDelete(PersonalPackageId) {
        return this._http.get(this.baseAPIurl + "/Admin/PersonalPackageDelete?PersonalPackageId=" + PersonalPackageId, this.options)

    }

};